import {css, html, LitElement, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';
import {MultiSelectionFilter} from '@webs/components-library/filters-dropdown';

@customElement('webs-filters-dropdown-desktop')
export class FiltersDropdownDesktop extends LitElement {

  private filters: Map<string, string[]> = new Map();
  private internalOffset = 0;
  private internalLimit: number;
  private afterToken: string;
  private results: Record<string, unknown>[];
  private totalCount = 0;

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
      .filters__wrapper {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        margin: 0 -.3rem -.6rem;
      }

      ::slotted(*){
        margin: 0 .3rem .6rem;
      }
    `
  ];

  @property({attribute: 'url'})
  rootUrl: string;

  @property({type: Number})
  set limit(value: number) {
    const oldValue = this.internalLimit;
    this.internalLimit = value;
    this.requestUpdate('limit', oldValue);
  }

  get limit(): number {
    return this.internalLimit;
  }

  @property({type: Number})
  set offset(value: number) {
    const oldValue = this.internalOffset;
    this.internalOffset = value;
    this.requestUpdate('offset', oldValue);
  }

  get offset(): number {
    return this.internalOffset;
  }

  protected render(): unknown {
    return html`
      <section class="filters">
        <div class="filters__wrapper">
          <slot></slot>
        </div>
      </section>
    `
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    document.addEventListener('DOMContentLoaded', evt => {
      const items = this.shadowRoot.querySelector('slot').assignedElements();
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        item.addEventListener('filteradd', (e: CustomEvent) => {
          const filter: MultiSelectionFilter = e.detail;
          this.filters.set(filter.key, filter.activeFilters);
          this.internalOffset = 0;
          delete this.results;
          this.totalCount = 0;
          this.dispatchResultsPage();
        });
      }
    });
  }

  protected updated(_changedProperties: PropertyValues) {
    super.updated(_changedProperties);
    this.dispatchResultsPage();
  }

  private dispatchResultsPage(): void {
    const requiredCount = this.offset + this.limit;
    if(Array.isArray(this.results) && (this.results.length >= requiredCount || requiredCount > this.totalCount )){
      const currentResults = this.results.slice(this.offset, requiredCount);
      this.dispatchResourcesChangeEvent(currentResults, this.totalCount);
    } else {
      this.getData()
    }
  }

  private dispatchResourcesChangeEvent(results: Record<string, unknown>[], total: number): void {
    this.dispatchEvent(new CustomEvent('resourceschange', {
      bubbles: true, detail: {
        objects: results,
        totalCount: total
      }
    }));
  }

  private getData(): void {
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const data = JSON.parse(xhttp.responseText);

        this.afterToken = data.paging ? data.paging.next.after : undefined;
        if(!Array.isArray(this.results)){
          this.results = [];
        }

        this.totalCount = data.total;
        this.results.push(... data.results);

        this.dispatchResultsPage();

      }
      //TODO: error handling
    };

    const urlSearchParams = new URLSearchParams();
    for (const name of this.filters.keys()) {
      const value = this.filters.get(name);
      if (value.length === 0) {
        continue;
      }
      urlSearchParams.set(`${name}__in`, this.filters.get(name).join(','));
    }

    if (this.limit) {
      const resultsLimit = this.limit * 10;
      urlSearchParams.set('limit', resultsLimit.toString());
    }

    if (this.afterToken){
      urlSearchParams.set('after', this.afterToken);
    }

    //if (this.offset) {
    //  urlSearchParams.set('offset', this.offset.toString());
    //}

      let url = this.rootUrl;
      const searchParams = urlSearchParams.toString();
      if (searchParams.length > 0 && !url.includes('?')) {
        url = `${url}?`;
      } else if (!url.endsWith('?')) {
        url = `${url}&`;
      }

      url = `${url}${searchParams}`;

    xhttp.open('GET', url, true);
    xhttp.send();
  }
}
